export default __webpack_public_path__ + "static/media/location.c2342941.svg";